import slugify from 'slugify'

function convertToSlug (path: string, page: string) {
  return slugify(`/${path}`, { lower: true }) + '/' + slugify(`${page}`, { lower: true })
}

export default convertToSlug
